import { useTranslation } from 'react-i18next';
import PlaceholderImg from '../../../../../assets/scheme_placeholder.svg';
import { GalleryCard } from "../../../../components/gallery/LibraryGalleryCard";
import { GalleryViewMode } from "../../../../components/gallery/types";
import { LibraryExerciseMaxConversion } from "../types";
import { ratioToPercentage } from "../utils";

export function MaxConversionCard({
  item,
  viewMode,
  onClick,
}: {
  item: LibraryExerciseMaxConversion;
  viewMode: GalleryViewMode;
  onClick: (item: LibraryExerciseMaxConversion) => void;
}) {
  const { t } = useTranslation();
  const {
    ratio,
    toLibraryExercise: { name: toExerciseName },
    fromLibraryExercise: { name: fromExerciseName },
  } = item;

  return (
    <GalleryCard
      title={toExerciseName}
      imgUrl={PlaceholderImg}
      viewMode={viewMode}
      onClick={() => onClick(item)}
    >
      <p>
          {t('maxConversionsDescription', { percentage: ratioToPercentage(ratio).toString(), fromExerciseName })}
      </p>
    </GalleryCard>
  );
}
